import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import 'react-toastify/dist/ReactToastify.css';
import { ITransaction } from '../interface/transaction';
import { useTranslation } from 'react-i18next';
import { API_URLS } from '../constants/apiUrl';
import { useLoading } from '../context/LoadingContext';
import { post } from '../api/api';
import { showToast } from '../components/utils/toast';
type TransactionPostingWithParams = {
  data: { date: string };
  params?: Record<string, string>;
};
const createTransactionPostingPeriod = async ({
  data,
}: TransactionPostingWithParams): Promise<ITransaction> => {
  return post(API_URLS.CREATE_TRANSACTION_POSTING_PERIOD, data, {
    skipGlobalErrorHandler: true,
  });
};

export const useCreateTransactionPostingPeriod = (): UseMutationResult<
  ITransaction,
  AxiosError<{ message?: string; type?: string }>,
  TransactionPostingWithParams
> => {
  const { setIsLoading } = useLoading();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: createTransactionPostingPeriod,
    onMutate: () => {
      setIsLoading(true);
    },
    onSuccess: () => {
      showToast('success', t('transaction:successfullyCreated'));
    },
    onSettled: () => {
      setIsLoading(false);
    },
  });
};
